import React from "react"
import { Divider } from "antd"
import logo from '../../../shared/assets/images/Logo.svg'
import downAi from '../../../shared/assets/images/darkDownAi.svg'
import { selectJobTitle } from "../slice/aiInterviewSlice"
import { useSelector } from "react-redux"
import { ReactComponent as AiChat } from "../../../shared/assets/images/AiChat.svg"
import { ReactComponent as AiUsers } from "../../../shared/assets/images/aiUsers.svg"
import { ReactComponent as AiInfo } from "../../../shared/assets/images/aiInfo.svg"
import { ReactComponent as AiQuestion } from "../../../shared/assets/images/aiQuestion.svg"
import { useLocation } from "react-router-dom"
import { OpenAiDownProps } from "./types"

const formatTime = (seconds: number): string => {
    const total = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0
    const mins = Math.floor(total / 60)
    const secs = total % 60
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`
}



const OpenAiDown: React.FC<OpenAiDownProps> = ({ elapsedTime: propElapsedTime, jobTitle: propJobTitle }) => {
    const location = useLocation();
    const state = (location.state || {});
    const storeJobTitle = useSelector(selectJobTitle)
    
    const jobTitle = propJobTitle || storeJobTitle || "Interview"
    const elapsedTime = propElapsedTime !== undefined 
        ? propElapsedTime 
        : (typeof state.elapsedTime === "number" ? state.elapsedTime : 0);

    return (
        <main className="relative flex flex-col min-h-screen overflow-hidden text-gray-300 bg-gray-800 min-w-screen">
            <div className="flex flex-wrap items-center justify-between w-full h-auto px-4 py-3 min-h-16 md:px-6">
                <div className="flex items-center gap-4 md:gap-6">
                    <img src={logo} alt="PeopleCQ" className="h-[1.65rem]" />
                    <div className="hidden text-sm font-medium text-gray-500 sm:block">v2.x</div>
                </div>
                <div className="flex flex-wrap items-center justify-end gap-2 mt-2 text-sm font-medium sm:gap-3 md:h-8 sm:mt-0 hover:cursor-pointer">
                    <div>{formatTime(elapsedTime)}</div>
                    <Divider type="vertical" className="hidden sm:block h-[1.125rem] border-gray-500" />
                    <div>{jobTitle}</div>
                    <Divider type="vertical" className="hidden sm:block h-[1.125rem] border-gray-500" />
                    <AiChat />
                    <AiUsers />
                    <AiInfo />
                    <AiQuestion />
                </div>
            </div>
            <div className="flex flex-col items-center justify-center gap-[1.125rem] h-screen w-full">
                <img src={downAi} alt="open ai down" />
                <div className="text-center">
                    <p className="text-xl font-semibold leading-8">Open AI is currently down!</p>
                    <p className="text-lg leading-6">Please try again later.</p>
                </div>
            </div>
        </main>
    )
}

export default OpenAiDown
